import LinearProgress, {
	linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

const BorderLinearProgress = styled(LinearProgress)(() => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: "#F4F4F5",
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		background: "linear-gradient(270deg, #00DCFE 0%, #0072CE 100%)",
	},
}));

export default BorderLinearProgress;
